import { customizationService } from 'core/services/customization/customization.service';
import type { TSliceExtraReducer } from 'core/store';
import { getCustomerIdFromCheckout } from 'core/store/checkout/checkout-state.utils';
import { createAppAsyncThunk } from 'core/store/store.utils';
import { SLICE_NAMESPACE } from '../constants';
import { ICustomizationState } from '../types';

export const getCustomizationElementsAction = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/getCustomizationElements`,
  async (_, { getState }) => {
    const { checkout } = getState();
    const customerId = getCustomerIdFromCheckout(checkout);
    const [bannersResult, shortcutsResult] = await Promise.allSettled([
      customizationService.getBanners(customerId),
      customizationService.getShortcuts(customerId),
    ]);

    const banners = bannersResult.status === 'fulfilled' ? bannersResult.value : [];
    const shortcuts = shortcutsResult.status === 'fulfilled' ? shortcutsResult.value : [];

    return { banners, shortcuts };
  },
);

export const getCustomizationElementsReducer: TSliceExtraReducer<ICustomizationState> = builder => {
  builder
    .addCase(getCustomizationElementsAction.pending, state => {
      state.banners = [];
      state.shortcuts = [];
      state.isLoading = true;
    })
    .addCase(getCustomizationElementsAction.rejected, state => {
      state.banners = [];
      state.shortcuts = [];
      state.isLoading = false;
    })
    .addCase(getCustomizationElementsAction.fulfilled, (state, { payload }) => {
      const { banners = [], shortcuts = [] } = payload;

      state.banners = banners;
      state.shortcuts = shortcuts;
      state.isLoading = false;
    });

  return builder;
};
